<script setup lang="ts">
import {loadStripe} from '@stripe/stripe-js'
import {onMounted, ref, watch} from 'vue'

const props = defineProps({
  currentPayment: Object,
})

const currentPaymentState = ref(props.currentPayment)


const paymentStatus = ref('loading-sdk')
const emits = defineEmits(['success', 'error'])

const {STRIPE_PUB_KEY} = useRuntimeConfig().public
const stripe = await loadStripe(STRIPE_PUB_KEY)

let elements = stripe.elements()
const cardElement = elements.create('card', {
  hidePostalCode: true,
  style: {
    base: {
      iconColor: '#000000',
      backgroundColor: '#F5f5f5',
      color: '#000000',
      fontWeight: '500',
      fontSize: '20px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#000000',
      },
      '::placeholder': {
        color: '#999',
      },
    },
    invalid: {
      iconColor: '#f74850',
      color: '#f74850',
    },
  },
})

onMounted(() => {
  paymentStatus.value = 'waiting'
  cardElement.mount('#card-element')
})

watch(() => props.currentPayment, (newPayment) => {
  currentPaymentState.value = newPayment
}, {immediate: true})

const pay = async () => {
  try {
    const paymentIntent = currentPaymentState.value?.intent

    if (!paymentIntent) {
      console.error('Brak clientSecret!')
      document.querySelector('#payment-error').textContent = 'Błąd: Brak danych płatności.'
      emits('error')
      return
    }

    const {paymentIntent: pi, error} = await stripe.confirmCardPayment(paymentIntent, {
      payment_method: {
        card: cardElement,
      }
    });

    if (error) {
      console.error('Błąd płatności:', error)
      document.querySelector('#payment-error').textContent = error.message
      emits('error')
    } else if (pi?.status === 'succeeded') {
      emits('success')
      window.location.href = currentPaymentState.value.return_url
    }
  } catch (error) {
    console.error('Błąd przetwarzania płatności:', error)
    document.querySelector('#payment-error').textContent = 'Wystąpił błąd. Spróbuj ponownie.'
    emits('error')
  }
};


defineExpose({pay})
</script>

<template>
  <div>
    <p id="payment-error" role="alert" class="text-red-700 text-center font-semibold"></p>
    <transition name="fade-slide">
      <div
        class="card-container bg-neutral-100 rounded-xl p-4">
        <div id="card-element"></div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.card-container:has(.StripeElement--focus) {
  border: 0.5px solid rgba(243, 245, 247, 0.15);
  box-shadow: 0 0 0 0.5px #999;
}

.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-slide-enter-to, .fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>

<!--<script setup lang="ts">-->
<!--import {loadStripe} from '@stripe/stripe-js'-->
<!--import {onMounted, ref, watch} from 'vue'-->

<!--const props = defineProps({-->
<!--  currentPayment: Object,-->
<!--  paymentMethod: String-->
<!--})-->

<!--const emits = defineEmits(['success', 'error'])-->

<!--const {STRIPE_PUB_KEY} = useRuntimeConfig().public-->
<!--const stripe = await loadStripe(STRIPE_PUB_KEY)-->

<!--const currentPaymentState = ref(props.currentPayment)-->
<!--const blikCode = ref('')-->
<!--const cardElement = ref(null)-->
<!--const elements = stripe.elements()-->

<!--onMounted(() => {-->
<!--  if (props.paymentMethod === 'stripe') {-->
<!--    const card = elements.create('card', {-->
<!--      hidePostalCode: true,-->
<!--      style: {-->
<!--        base: {-->
<!--          iconColor: '#000000',-->
<!--          backgroundColor: '#F5f5f5',-->
<!--          color: '#000000',-->
<!--          fontWeight: '500',-->
<!--          fontSize: '20px',-->
<!--          fontSmoothing: 'antialiased',-->
<!--          ':-webkit-autofill': { color: '#000000' },-->
<!--          '::placeholder': { color: '#999' },-->
<!--        },-->
<!--        invalid: {-->
<!--          iconColor: '#f74850',-->
<!--          color: '#f74850',-->
<!--        },-->
<!--      },-->
<!--    })-->
<!--    card.mount('#card-element')-->
<!--    cardElement.value = card-->
<!--  }-->
<!--})-->

<!--watch(() => props.currentPayment, (newPayment) => {-->
<!--  currentPaymentState.value = newPayment-->
<!--}, {immediate: true})-->

<!--const pay = async () => {-->
<!--  const clientSecret = currentPaymentState.value?.intent-->
<!--  const returnUrl = currentPaymentState.value?.return_url-->

<!--  if (!clientSecret) {-->
<!--    document.querySelector('#payment-error')!.textContent = 'Brak clientSecret'-->
<!--    emits('error')-->
<!--    return-->
<!--  }-->

<!--  try {-->
<!--    let result-->

<!--    if (props.paymentMethod === 'stripe') {-->
<!--      result = await stripe.confirmCardPayment(clientSecret, {-->
<!--        payment_method: { card: cardElement.value }-->
<!--      })-->

<!--    } else if (props.paymentMethod === 'blik') {-->
<!--      if (!blikCode.value || blikCode.value.length !== 6) {-->
<!--        document.querySelector('#payment-error')!.textContent = 'Wprowadź poprawny kod BLIK (6 cyfr)'-->
<!--        emits('error')-->
<!--        return-->
<!--      }-->

<!--      result = await stripe.confirmBlikPayment(clientSecret, {-->
<!--        payment_method: {-->
<!--          blik: {},-->
<!--          billing_details: {-->
<!--            email: 'email@example.com',-->
<!--          }-->
<!--        },-->
<!--        payment_method_options: {-->
<!--          blik: {-->
<!--            code: blikCode.value,-->
<!--          },-->
<!--        },-->
<!--      })-->

<!--    } else if (props.paymentMethod === 'p24') {-->
<!--      result = await stripe.confirmP24Payment(clientSecret, {-->
<!--        payment_method: {-->
<!--          p24: {},-->
<!--          billing_details: {-->
<!--            email: 'email@example.com',-->
<!--          },-->
<!--        },-->
<!--        return_url: returnUrl,-->
<!--      })-->
<!--    }-->

<!--    if (result.error) {-->
<!--      document.querySelector('#payment-error')!.textContent = result.error.message-->
<!--      emits('error')-->
<!--    } else if (result.paymentIntent?.status === 'succeeded') {-->
<!--      emits('success')-->
<!--      window.location.href = returnUrl-->
<!--    }-->

<!--  } catch (error) {-->
<!--    console.error(error)-->
<!--    document.querySelector('#payment-error')!.textContent = 'Wystąpił błąd płatności'-->
<!--    emits('error')-->
<!--  }-->
<!--}-->

<!--defineExpose({ pay })-->
<!--</script>-->

<!--<template>-->
<!--  <div>-->
<!--    <p id="payment-error" role="alert" class="text-red-700 text-center font-semibold"></p>-->

<!--    <transition name="fade-slide">-->
<!--      <div class="card-container bg-neutral-100 rounded-xl p-4">-->
<!--        <div v-if="paymentMethod === 'stripe'" id="card-element"></div>-->

<!--        <div v-if="paymentMethod === 'blik'" class="flex flex-col gap-2">-->
<!--          <label for="blik-code" class="font-medium">Wprowadź kod BLIK</label>-->
<!--          <input-->
<!--            id="blik-code"-->
<!--            v-model="blikCode"-->
<!--            maxlength="6"-->
<!--            pattern="[0-9]{6}"-->
<!--            type="text"-->
<!--            placeholder="123456"-->
<!--            class="w-full border rounded px-3 py-2"-->
<!--          />-->
<!--        </div>-->

<!--        <div v-if="paymentMethod === 'p24'" class="text-center font-medium text-sm">-->
<!--          Po kliknięciu "Zapłać", zostaniesz przekierowany do strony banku.-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->
<!--  </div>-->
<!--</template>-->

<!--<style scoped>-->
<!--.fade-slide-enter-active, .fade-slide-leave-active {-->
<!--  transition: opacity 0.5s ease, transform 0.5s ease;-->
<!--}-->

<!--.card-container:has(.StripeElement&#45;&#45;focus) {-->
<!--  border: 0.5px solid rgba(243, 245, 247, 0.15);-->
<!--  box-shadow: 0 0 0 0.5px #999;-->
<!--}-->

<!--.fade-slide-enter-from, .fade-slide-leave-to {-->
<!--  opacity: 0;-->
<!--  transform: translateY(-20px);-->
<!--}-->

<!--.fade-slide-enter-to, .fade-slide-leave-from {-->
<!--  opacity: 1;-->
<!--  transform: translateY(0);-->
<!--}-->
<!--</style>-->
